import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "label", "loading", "optionProps", "value", "defaultValue", "valueChange", "onChange", "error", "errMessage"],
    _excluded2 = ["name", "control", "rules", "defaultValue", "valueChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useImperativeHandle, useState } from 'react';
import { StyleTextField } from '@jove-frontend/mui';
import { Autocomplete, Box, CircularProgress, FormHelperText } from '@mui/material';
import clsx from 'clsx';
import { useController } from 'react-hook-form';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var JoveMultipleAutocomplete = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      label = props.label,
      loading = props.loading,
      _props$optionProps = props.optionProps,
      optionProps = _props$optionProps === void 0 ? {
    value: 'value',
    label: 'label'
  } : _props$optionProps,
      value = props.value,
      defaultValue = props.defaultValue,
      valueChange = props.valueChange,
      onChange = props.onChange,
      error = props.error,
      errMessage = props.errMessage,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(defaultValue || []),
      inputValue = _useState[0],
      setInputValue = _useState[1];
  /**
   * methods
   */


  var selectChangeAction = function selectChangeAction(event, newValue) {
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
    setInputValue(newValue);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(newValue);
  }; // update current select item


  var updateSelectItem = function updateSelectItem(item) {
    setInputValue(item);
  };

  useImperativeHandle(ref, function () {
    return {
      updateSelectItem: updateSelectItem
    };
  });
  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    children: [/*#__PURE__*/_jsx(Autocomplete, _objectSpread(_objectSpread({
      ref: ref,
      isOptionEqualToValue: function isOptionEqualToValue(option, value) {
        return (option === null || option === void 0 ? void 0 : option[optionProps === null || optionProps === void 0 ? void 0 : optionProps.value]) === (value === null || value === void 0 ? void 0 : value[optionProps === null || optionProps === void 0 ? void 0 : optionProps.value]);
      },
      getOptionLabel: function getOptionLabel(option) {
        return option[optionProps.label];
      }
    }, rest), {}, {
      value: value === undefined ? inputValue : value || [],
      loading: loading,
      onChange: selectChangeAction,
      multiple: true,
      renderInput: function renderInput(params) {
        return /*#__PURE__*/_jsx(StyleTextField, _objectSpread(_objectSpread({}, params), {}, {
          label: label,
          InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
            endAdornment: /*#__PURE__*/_jsxs(_Fragment, {
              children: [loading ? /*#__PURE__*/_jsx(CircularProgress, {
                color: "inherit",
                size: 20
              }) : null, params.InputProps.endAdornment]
            })
          })
        }));
      }
    })), error && /*#__PURE__*/_jsx(FormHelperText, {
      className: "react-hook-form-error",
      error: error,
      children: errMessage
    })]
  });
});
export var JoveMultipleAutocompleteControlled = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      valueChange = props.valueChange,
      rest = _objectWithoutProperties(props, _excluded2);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  var valueChangeAction = function valueChangeAction(value) {
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: "flex flex-col",
    children: /*#__PURE__*/_jsx(JoveMultipleAutocomplete, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      value: value,
      valueChange: valueChangeAction,
      defaultValue: defaultValue,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
});
export default JoveMultipleAutocomplete;